<template>
    <component
        :is="`${tab}View`"
        :tabSelected="tab"
        :defaultDate="date"
        :defaultSelectedPost="defaultSelectedPost"
        @changeTab="changeTab"
    />
</template>

<script>
    import ListView from '@/components/dash/posts/List.vue'
    import PlannerView from '@/components/dash/posts/Planner.vue'
    import FeedView from '@/components/dash/posts/Feed.vue'
    import ModalSwitchVersion from '@/components/dash/posts/components/ModalSwitchVersion.vue'
    import postMixins from '@/components/mixins/Posts.vue'
    import draftMixins from '@/components/mixins/Drafts.vue'
    export default {
        mixins: [postMixins, draftMixins],
        components: {
            ListView,
            PlannerView,
            FeedView,
            ModalSwitchVersion
        },
        props: {
            date: {
                type: String,
                default: null
            },

            //Lien profond
            post_id: {
                type: String,
                default: null
            },
            page_id: {
                type: String,
                default: null
            },
            bot_id: {
                type: String,
                default: null
            },
            is_draft: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                tab: 'planner',
                defaultSelectedPost: null
            }
        },

        mounted () {
            if (this.post_id && this.page_id && this.bot_id) {
                this.setupDefaultSelectedPost()
            }
        },
        methods: {
            changeTab(tabName) {
                if (!['list', 'planner','feed'].includes(tabName)) return
                this.tab = tabName
            },
            async setupDefaultSelectedPost(){
                let res = null
                if (this.is_draft === true || this.is_draft === 'true') {
                    res = await this.findDraft(this.bot_id, this.post_id)
                }else {
                    res = await this.getPost(this.bot_id, this.post_id)
                }
                    
                if(res && res.body && res.body.post){
                    this.tab = 'planner',
                    this.defaultSelectedPost = res.body.post
                    this.date = res.body.post.scheduled_date
                }
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>